// Copyright (c) 2020-2023 Visual Intelligence LP. All rights reserved.
//

export const downloadFile = async (blobParts: BlobPart[], filename: string, contentType = 'application/octet-stream') => {
  const a = document.createElement('a');

  const blob = new Blob(blobParts, { type: contentType });

  // Note: if blobParts contain character string, Blob may insert encoded string to the datastream.
  // Must convert the string to Int8Array then use blob = new Blob([i8s_var_here]);
  //console.log("********** Download Blob:", await blob.arrayBuffer());

  a.href = window.URL.createObjectURL(blob);
  a.download = filename;
  a.click();
};

export const downloadFileNoType = async (blobParts: BlobPart[], filename: string) => {
  const a = document.createElement('a');

  const blob = new Blob(blobParts);
  
  a.href = window.URL.createObjectURL(blob);
  a.download = filename;
  a.click();
};

// Wrap file data in html multipart/form-data format.
export const createFormDataName = (file: File) => {
  const formData = new FormData();

  formData.append(file.name, file);

  return formData;
}; 